import { Action } from "redux";
import { IClientContractActionCreator } from "../action/client_contract_action";
import {
  CreateContractByClientRequest,
  UpdateContractByClientRequest,
  OpenCreateFormContractByClientRequest,
  ApproveContractByClientRequest,
} from "../request/contract_request";

interface IClientContractDispatcher {
  createContract(item: CreateContractByClientRequest): void;

  updateContract(item: UpdateContractByClientRequest): void;

  openCreateForm(item: OpenCreateFormContractByClientRequest): void;

  approveContract(item: ApproveContractByClientRequest): void;
}

class Dispatcher implements IClientContractDispatcher {
  constructor(
    private dispatch: (action: Action) => void,
    private actionCreator: IClientContractActionCreator
  ) {}

  public createContract = (item: CreateContractByClientRequest): void => {
    this.dispatch(this.actionCreator.requestCreateContractAction(item));
  };

  public updateContract = (item: UpdateContractByClientRequest): void => {
    this.dispatch(this.actionCreator.requestUpdateContractAction(item));
  };

  public openCreateForm = (
    item: OpenCreateFormContractByClientRequest
  ): void => {
    this.dispatch(this.actionCreator.requestOpenCreateFormContractAction(item));
  };

  public approveContract = (item: ApproveContractByClientRequest): void => {
    this.dispatch(this.actionCreator.requestApproveContractAction(item));
  };
}

const createClientContractDispatcher = (
  dispatch: (action: Action) => void,
  actionCreator: IClientContractActionCreator
): IClientContractDispatcher => {
  return new Dispatcher(dispatch, actionCreator);
};

export { IClientContractDispatcher, createClientContractDispatcher };



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_contract_dispatcher.ts